import React, { useEffect, useState } from "react";
import { ChevronLeft } from "react-feather";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import api from "../../api";
import OrderStatus from "../../Component/OrderStatus";
import { formateDate } from "../../reducers/utils";

export default function OrderDetailsPage() {
  const [params] = useSearchParams();
  const id = params.get("orderId");
  const [order, setOrder] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);

  useEffect(() => {
    (async () => {
      const resp = await api.fetchOrderDetails(id);
      if (resp.status !== "ok") {
        navigate("/404");
      }
      console.log("single order", resp.order);
      setOrder(resp.order);
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      const resp = await api.orderStatus(id);
      console.log("order status", resp);
      if (!resp.status) {
        navigate("/404");
      }
      setOrderStatus(resp);
    })();
  }, [id]);

  const handleDeleteOrder = async (orderId) => {
    try {
      const resp = await api.deleteOrder(orderId);
      if (resp.status == "ok") {
        navigate("/orders");
        // window.location.reload()
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <main className="container py-5">
      {/* Back Button */}
      <button
        className="btn btn-outline-secondary mb-4"
        onClick={() => window.history.back()}
      >
        <i className="bi bi-arrow-left me-2"></i>
        Back
      </button>

      {/* Order Card */}
      <div className="card shadow-lg border-0 rounded-4">
        {/* Header */}
        <div className="card-header bg-white py-4 border-bottom">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <h3 className="mb-1 fw-bold">Order Details</h3>
              <p className="text-muted mb-0">
                Order ID : <strong>#{id}</strong>
              </p>
            </div>

            <div className="text-end">
              <small className="text-muted d-block">Order Date</small>
              <strong>
                {formateDate(order?.createdAt)}
              </strong>
            </div>
          </div>
        </div>

        <div className="card-body">
          {/* Order Status */}
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <h5 className="mb-3">Order Status</h5>

              <OrderStatus currentStatus={orderStatus?.status} />
            </div>
          </div>

          {/* Address + Contact */}

          <div className="row g-4 mb-4">
            <div className="col-lg-6">
              <div className="card h-100 border shadow-sm">
                <div className="card-body">
                  <h5 className="mb-3">
                    <i className="bi bi-geo-alt-fill me-2 text-success"></i>
                    Shipping Address
                  </h5>

                  <p className="fw-semibold mb-1">{order?.address?.name}</p>

                  <p className="mb-1">{order?.address?.area}</p>

                  <p className="mb-1">
                    {order?.address?.city}, {order?.address?.state}
                  </p>

                  <p className="mb-1">{order?.address?.country}</p>

                  <p className="mb-0">{order?.address?.pincode}</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="card h-100 border shadow-sm">
                <div className="card-body">
                  <h5 className="mb-3">
                    <i className="bi bi-telephone-fill me-2 text-primary"></i>
                    Contact Details
                  </h5>

                  <p className="mb-2">
                    <strong>Name :</strong> {order?.address?.name}
                  </p>

                  <p className="mb-0">
                    <strong>Phone :</strong> {order?.address?.phone}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Shipment Details */}

          {orderStatus?.data && (
            <div className="card border shadow-sm mb-4">
              <div className="card-header bg-light">
                <h5 className="mb-0">Shipment Details</h5>
              </div>

              <div className="card-body">
                <div className="row">
                  {orderStatus?.data.invoice_no && (
                    <div className="col-md-6 mb-3">
                      <strong>Invoice No:</strong>
                      <br />
                      {orderStatus?.data.invoice_no}
                    </div>
                  )}

                  {orderStatus?.data.despatch_mode && (
                    <div className="col-md-6 mb-3">
                      <strong>Dispatch Mode:</strong>
                      <br />
                      {orderStatus?.data.despatch_mode}
                    </div>
                  )}

                  {orderStatus?.data.gr_date && (
                    <div className="col-md-6 mb-3">
                      <strong>Shipping Date:</strong>
                      <br />
                      {orderStatus?.data.gr_date}
                    </div>
                  )}

                  {orderStatus?.data.gr_no && (
                    <div className="col-md-6 mb-3">
                      <strong>Tracking Number:</strong>
                      <br />
                      {orderStatus?.data.gr_no}
                    </div>
                  )}

                  {orderStatus?.status === "Delivered" &&
                    orderStatus?.data.rec_date && (
                      <div className="col-md-6">
                        <strong>Delivered On:</strong>
                        <br />
                        {orderStatus?.data.rec_date}
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}

          {/* Products */}

          <div className="card shadow-sm border mb-4">
            <div className="card-header bg-light">
              <h5 className="mb-0">Ordered Products</h5>
            </div>

            <div className="card-body p-0">
              {order?.products?.map((product) => (
                <div
                  key={product.itemId}
                  className="d-flex justify-content-between align-items-center p-3 border-bottom flex-wrap"
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={product.image}
                      alt={product.title}
                      className="rounded border me-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                      }}
                    />

                    <div>
                      <h6
                        className="mb-1"
                        style={{
                          maxWidth: "300px",
                        }}
                      >
                        {product.title}
                      </h6>

                      <small className="text-muted">{product.type}</small>
                    </div>
                  </div>

                  <div className="text-end">
                    <p className="mb-1">
                      Qty :<strong> {product.quantity}</strong>
                    </p>

                    <h6 className="text-success mb-0">₹{product.price}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}

        <div className="card-footer bg-white">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div>
              <h4 className="mb-0 fw-bold">Total : ₹{order?.amount}</h4>
            </div>

            {orderStatus?.status !== "Delivered" &&
              orderStatus?.status !== "Cancelled" && (
                <button
                  className="btn btn-danger px-4"
                  onClick={() => handleDeleteOrder(id)}
                >
                  Cancel Order
                </button>
              )}
          </div>
        </div>
      </div>
    </main>
  );
}
